const FETCH_EVENT_RECORDS_INITIATED = 'FETCH_EVENT_RECORDS_INITIATED';
const FETCH_EVENT_RECORDS_SUCCEEDED = 'FETCH_EVENT_RECORDS_SUCCEEDED';
const FETCH_EVENT_RECORDS_FAILED = 'FETCH_EVENT_RECORDS_FAILED';

export default {
  FETCH_EVENT_RECORDS_INITIATED,
  FETCH_EVENT_RECORDS_SUCCEEDED,
  FETCH_EVENT_RECORDS_FAILED,
};
